// Programmation (publications, stories, directs) : au plus SCHEDULE_MAX_DAYS à l'avance (miroir de shared.SCHEDULE_MAX_DAYS).
export const SCHEDULE_MAX_DAYS = 92;

const toLocalInput = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);

export const maxDatetimeLocal = () => toLocalInput(new Date(Date.now() + SCHEDULE_MAX_DAYS * 86400000));
